import {
  BodyText,
  Flex,
  Heading,
  Strong,
} from '@utilitywarehouse/hearth-react';
import { BroadbandMediumIcon } from '@utilitywarehouse/hearth-react-icons';

import { WiFiTile } from './WifiTile';
import './styles.scss';
import { UpgradeWiFiProps } from './types';

const UpgradeWiFi = ({
  price,
  isSelected,
  onSelect: onChange,
}: UpgradeWiFiProps) => (
  <div className="wrapper" data-testid="broadband-upgrade-section">
    <Flex asChild direction="column" spacing="lg">
      <section className="upgrade-wifi__wrapper">
        <Flex direction="column" spacing="xl" asChild>
          <header>
            <Heading as="h2" size="lg">
              Upgrade your Wi-Fi
            </Heading>
            <Flex gap="100" alignItems="center">
              <BroadbandMediumIcon />

              <BodyText>
                Our UW Wi-Fi 7 Pro Hub is <Strong>included free</Strong> with
                all our broadband plans.
              </BodyText>
            </Flex>
          </header>
        </Flex>
        <WiFiTile price={price} isSelected={isSelected} onSelect={onChange} />
      </section>
    </Flex>
  </div>
);

export { UpgradeWiFi };
